'use client'

import React, { useEffect, useState } from 'react'
import Link from 'next/link'

interface Quote {
    key: Key
    pricedata: PriceData
    graphUrl: string
}

interface Key {
    symbol: string
}

interface PriceData {
    last: number
    change: number
    changepercent: number
}

export const StockTicker: React.FC = () => {
    const [quotes, setQuotes] = useState<Quote[] | null>(null)
    const symbols = ['NVDA', 'WMT', 'COF', 'COIN', 'RDFN', 'CMCSA', 'NWS', 'DOOO', 'HOG', 'TSLA', 'HYMTF']

    useEffect(() => {
        const fetchQuotes = async () => {
            try {
                const host = window.location.hostname
                const data = await fetch(`https://stocks.${host}/?symbols=${symbols.join(',')}`).then((result) => result.json())

                setQuotes(data.results.quote || [])
            } catch (err: any) {
                /* noop */
            }
        }

        fetchQuotes()
    }, [])

    return (
        <div className='mb-4'>
            <div className='w-full inline-flex flex-nowrap overflow-hidden'>
                <div className='flex gap-4 [&_ul]:hover:[animation-play-state:paused]'>
                    <ul className='animate-infinite-scroll flex gap-4 items-center justify-center md:justify-start [&_img]:max-w-none '>
                        {quotes?.map((quote) => (
                            <li key={quote.key.symbol}>
                                <Link className='text-sm flex gap-2' href={`/quote/${quote.key.symbol}`} target='_blank'>
                                    <div>
                                        <div className='font-semibold'>{quote.key.symbol}</div>
                                        <div className='font-light hidden md:block'>${roundAndPad(quote.pricedata.last)}</div>
                                    </div>
                                    <div>
                                        <div
                                            className='font-semibold'
                                            style={{ color: quote.pricedata.changepercent >= 0 ? 'rgb(0, 164, 26)' : 'rgb(198, 69, 68)' }}
                                        >
                                            {formatChange(quote.pricedata.changepercent)}%
                                        </div>
                                        <div
                                            className='font-semibold hidden md:block'
                                            style={{ color: quote.pricedata.change >= 0 ? 'rgb(0, 164, 26)' : 'rgb(198, 69, 68)' }}
                                        >
                                            {formatChange(quote.pricedata.change)}
                                        </div>
                                    </div>
                                    <div className='hidden md:flex md:flex-col md:justify-end'>
                                        <img width='60' src={quote.graphUrl} />
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <ul className='animate-infinite-scroll flex gap-4 items-center justify-center md:justify-start [&_img]:max-w-none'>
                        {quotes?.map((quote) => (
                            <li key={quote.key.symbol}>
                                <Link className='text-sm flex gap-2' href={`/quote/${quote.key.symbol}`} target='_blank'>
                                    <div>
                                        <div className='font-semibold'>{quote.key.symbol}</div>
                                        <div className='font-light hidden md:block'>${roundAndPad(quote.pricedata.last)}</div>
                                    </div>
                                    <div>
                                        <div
                                            className='font-semibold'
                                            style={{ color: quote.pricedata.changepercent >= 0 ? 'rgb(0, 164, 26)' : 'rgb(198, 69, 68)' }}
                                        >
                                            {formatChange(quote.pricedata.changepercent)}%
                                        </div>
                                        <div
                                            className='font-semibold hidden md:block'
                                            style={{ color: quote.pricedata.change >= 0 ? 'rgb(0, 164, 26)' : 'rgb(198, 69, 68)' }}
                                        >
                                            {formatChange(quote.pricedata.change)}
                                        </div>
                                    </div>
                                    <div className='hidden md:flex md:flex-col md:justify-end'>
                                        <img width='60' src={quote.graphUrl} />
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

function formatChange(change: number) {
    const _change = roundAndPad(change)
    return `${change > 0 ? '+' : ''}${_change}`
}

function roundAndPad(number: number) {
    const rounded = Math.round((number + Number.EPSILON) * 100) / 100
    const roundedString = rounded.toFixed(2)
    return roundedString
}

export default StockTicker
